var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dashboard-container"},[_c(_vm.currentRole,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }